import { useEffect, useRef } from "react";
import { landingMarkup } from "../landing/markup";
import { startLanding } from "../landing/app";
import "../landing/css/style.css";

export function HomePage() {
    const rootRef = useRef(null);

    useEffect(() => {
        const html = document.documentElement;
        html.classList.add("landing-on");
        document.body.setAttribute("data-page", "home");
        const stop = startLanding(rootRef.current);
        return () => {
            stop();
            html.classList.remove("landing-on");
            document.body.removeAttribute("data-page");
        };
    }, []);

    return (
        <div
            className="landing"
            ref={rootRef}
            dangerouslySetInnerHTML={{ __html: landingMarkup }}
        />
    );
}
